import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { closeBtn, dialogActions, dialogTitle, paperProps, title } from './NameChangeModal.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessModal from 'app/components/SuccessModal';
import CustomInput from 'app/components/CustomInput';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  selectName: string;
  headerText: string;
  inputTitle: string;
}

const NameChangeModal = (props: Props) => {
  const { open, close, selectName, headerText, inputTitle } = props;
  const [successModal, setSuccessModal] = useState(false);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
      >
        <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
          <Typography sx={title}>{headerText}</Typography>
          <Button
            color={'tertiary'}
            onClick={() => {
              close(false);
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent sx={{ pl: '40px' }}>
          <CustomInput title={inputTitle} placeholder={selectName} />
        </DialogContent>
        <DialogActions sx={dialogActions}>
          <Button
            onClick={() => {
              close(false);
              setSuccessModal(true);
            }}
          >
            Yadda saxla
          </Button>
          <Button
            color={'secondary'}
            sx={{ ml: '0 !important' }}
            onClick={() => {
              close(false);
            }}
          >
            Ləğv et
          </Button>
        </DialogActions>
      </Dialog>
      <SuccessModal open={successModal} close={setSuccessModal} successText={'Dəyişiklər uğurla yadda saxlanıldı!'} />
    </>
  );
};

export default NameChangeModal;
